import React, { type ReactNode } from 'react';
import Box from '@mui/material/Box';

import styles from 'src/components/tabs-bar/TabsBar.module.css';

type TabsBarProps = {
    leading?: ReactNode;
    children: ReactNode;
    trailing?: ReactNode;
};

export default function TabsBar({
    leading,
    children,
    trailing,
}: TabsBarProps) {
    return (
        <Box className={styles.root}>
            <Box className={styles.inner}>
                {leading}
                {children}
            </Box>

            {trailing && (
                <Box className={styles.trailing}>
                    {trailing}
                </Box>
            )}
        </Box>
    );
}
